/** Normalize pay month from yyyy-mm, yyyy-mm-dd, or DatePicker yyyy-mm-dd/yyyy-mm-dd range. */
export function parsePayMonthValue(raw) {
  if (raw == null || raw === "") return "";
  const s = String(raw).trim();
  const m = s.match(/^(\d{4}-\d{2})/);
  return m ? m[1] : "";
}

export function payMonthToDatePickerValue(payMonth) {
  const normalized = parsePayMonthValue(payMonth);
  return normalized ? `${normalized}-01` : "";
}
